import React, { useState } from 'react';
import './About.css';
import { FaLinkedin } from 'react-icons/fa';

const About = () => {
    const [showPopup, setShowPopup] = useState(false);

    const handlePopupToggle = () => {
        setShowPopup(!showPopup);
    };

    return (
        <div className="about-container">
            {/* Welcome Section */}
            <section className="about-welcome">
                <h1><strong>About Salva</strong></h1>
                <p>Making taxes simple, stress-free, and insightful for everyone.</p>
            </section>

            {/* Our Mission Section */}
            <section className="about-section">
                <h2>Our Mission</h2>
                <p> It took thousands of returns and almost a decade in the tax preparation industry for Justin "JJ" Jiang to realize that of all the necessary burdens in this world, filing taxes should <strong>not</strong> be one of them.
                    <br></br>
                    Thus, Salva Tax was born.
                    <br></br>
                    <br></br>
                    Our mission is to <strong>increase</strong> financial and tax literacy, offer <strong>stress-free</strong> tax filing, and <strong>empower</strong> our clients with simplified financial insights.
                    </p>
            </section>

            {/* What We Do Section */}
            <section className="about-section">
                <h2>What We Do</h2>
                <p> We strive to achieve our mission in three ways:
                    <br></br>
                <br></br>
                    <ul>
                        <li>Be a one-stop resource for the latest tax rules, updates, and strategies. All for free.</li>
                        <br></br>
                        <li>Provide our clients with the best full-service and worry-free tax filing experience.</li>
                        <br></br>
                        <li>Empower our clients with the data and insights they need to make smart financial decisions.</li>
                    </ul>
                     </p>
            </section>

            {/* Meet the Team Section */}
            <section className="meet-the-team">
                <h2>Meet the Team</h2>
                <div className="team-card" onClick={handlePopupToggle}>
                    <div className="team-image">
                        <img src={`${process.env.PUBLIC_URL}/images/jj.png`} alt="Justin Jiang" />
                        <div className="overlay">
                            <h3><strong>Justin Jiang</strong></h3>
                            <p>Founder, Tax Afficionado</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Popup Modal */}
            {showPopup && (
                <div className="popup-overlay" onClick={handlePopupToggle}>
                    <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-btn" onClick={handlePopupToggle}>&times;</button>
                        <div className="popup-body">
                            {/*<img src={`${process.env.PUBLIC_URL}/images/jj.png`} alt="Justin Jiang" />*/}
                            <div className="popup-info">
                                <h2><strong>JJ</strong></h2>
                                <p><strong>Area of Experience</strong>
                                    <br></br>
                                    Tax Preparation, Filing, Strategy, Real Estate, Self-Employment Taxes</p>
                                <p><strong>Education</strong>
                                    <br></br>
                                    BS & MS - Electrical Engineering, Georgia Tech
                                    <br></br>
                                    MS - Mechanical Engineering, MIT
                                    <br></br>
                                    MBA - MIT Sloan
                                </p>
                                <p><strong>Connect with JJ</strong> </p>
                                <a href="https://www.linkedin.com/in/jiang-justin/" target="_blank" rel="noopener noreferrer">
                                    <FaLinkedin className="linkedin-icon" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default About;
